import { FieldInfoRegistry } from '../../../shared/field-info/field-info.types';

/**
 * Metadados dos campos do wizard de cadastro de cupom.
 * Fonte de verdade: scripts-oracle/cp_ddl_v2.sql.
 */
export const CUPOM_WIZARD_FIELD_INFO: FieldInfoRegistry = {
  // ── Passo 1: Básico ──
  'cupom.codigo': {
    label: 'Código',
    attribute: 'COD_CUPOM',
    table: 'CP_CUPOM',
    type: 'VARCHAR2(50)',
    description: 'Código alfanumérico digitado no campo DS_OBSERVACAO da CONTA_PACIENTE para acionar o cupom.',
  },
  'cupom.descricao': {
    label: 'Descrição',
    attribute: 'DS_CUPOM',
    table: 'CP_CUPOM',
    type: 'VARCHAR2(255)',
  },
  'cupom.observacao': {
    label: 'Observação interna',
    attribute: 'DS_OBSERVACAO',
    table: 'CP_CUPOM',
    type: 'VARCHAR2(2000)',
  },
  'cupom.tipo': {
    label: 'Tipo do cupom',
    attribute: 'IE_TIPO',
    table: 'CP_CUPOM',
    type: "CHAR(1) IN ('P','C','E','A','G')",
    description: 'P=Todos, C=B2C CartaoSIM, E=Empresa B2B, A=Assinantes (B2C+B2B), G=Geral (todos).',
  },
  'cupom.tipoDesconto': {
    label: 'Tipo de desconto',
    attribute: 'IE_TIPO_DESCONTO',
    table: 'CP_CUPOM',
    type: "CHAR(1) IN ('R','P','F','V')",
    description: 'R=Real fixo, P=Percentual, F=Preço fixo (paciente paga X), V=Voucher 100% grátis.',
  },
  'cupom.percentual': {
    label: 'Percentual',
    attribute: 'PR_DESCONTO',
    table: 'CP_CUPOM',
    type: 'NUMBER(15,4)',
    description: 'Preenchido quando IE_TIPO_DESCONTO = P.',
  },
  'cupom.valorDesconto': {
    label: 'Valor de desconto',
    attribute: 'VL_DESCONTO',
    table: 'CP_CUPOM',
    type: 'NUMBER(15,2)',
    description: 'Preenchido quando IE_TIPO_DESCONTO = R ou F.',
  },
  'cupom.tetoDesconto': {
    label: 'Teto de desconto',
    attribute: 'VL_MAXIMO_DESCONTO',
    table: 'CP_CUPOM',
    type: 'NUMBER(15,2)',
  },
  'cupom.dtInicio': {
    label: 'Início da vigência',
    attribute: 'DT_VIGENCIA_INI',
    table: 'CP_CUPOM',
    type: 'DATE',
    description: 'Janela em que o cupom pode ser emitido.',
  },
  'cupom.dtFim': {
    label: 'Fim da vigência',
    attribute: 'DT_VIGENCIA_FIM',
    table: 'CP_CUPOM',
    type: 'DATE',
  },
  'cupom.qtMaxUsos': {
    label: 'Total máx. de usos',
    attribute: 'QT_ESTOQUE_TOTAL',
    table: 'CP_CUPOM',
    type: 'NUMBER(10)',
    description: 'Estoque global do cupom em todo o programa.',
  },
  'cupom.qtPorPessoa': {
    label: 'Por pessoa',
    attribute: 'QT_LIMITE_PESSOA',
    table: 'CP_CUPOM',
    type: 'NUMBER(5)',
  },
  'cupom.bloqueioDias': {
    label: 'Bloqueio entre usos',
    attribute: 'NR_DIAS_BLOQUEIO_REUSO',
    table: 'CP_CUPOM',
    type: 'NUMBER(5)',
    description: 'Após o uso, paciente fica bloqueado por X dias.',
  },

  // ── Passo 2: Procedimentos ──
  'cupom.regraProc.classif': {
    label: 'Classificação',
    attribute: 'NR_SEQ_CLASSIF',
    table: 'CP_REGRA_PROCEDIMENTO',
    type: 'NUMBER(10)',
    description: 'Classificação do PROC_INTERNO (1=Lab, 12+17=Odonto, 13=Consultas).',
  },
  'cupom.regraProc.individual': {
    label: 'Procedimento individual',
    attribute: 'CD_PROCEDIMENTO',
    table: 'CP_REGRA_PROCEDIMENTO',
    type: 'NUMBER(15)',
    description: 'Mutuamente exclusivo com NR_SEQ_CLASSIF.',
  },

  // ── Passo 4: Filtros ──
  'cupom.regra.plano': {
    label: 'Restringir por plano B2C',
    attribute: 'CD_PLAN_B2C',
    table: 'CP_REGRA_PLANO',
    type: 'NUMBER',
  },
  'cupom.regra.empresa': {
    label: 'Restringir por empresa B2B',
    attribute: 'CD_EMPRESA',
    table: 'CP_REGRA_EMPRESA',
    type: 'NUMBER',
  },
  'cupom.regra.estab': {
    label: 'Restringir por estabelecimento',
    attribute: 'CD_ESTABELECIMENTO',
    table: 'CP_REGRA_ESTABELECIMENTO',
    type: 'NUMBER',
  },
  'cupom.regra.prof': {
    label: 'Restringir por profissional',
    attribute: 'CD_PESSOA_FISICA',
    table: 'CP_REGRA_PROFISSIONAL',
    type: 'VARCHAR2(10)',
  },
  'cupom.regra.idadeMin': {
    label: 'Idade mínima',
    attribute: 'QT_IDADE_MIN',
    table: 'CP_REGRA_FAIXA_ETARIA',
    type: 'NUMBER(3)',
  },
  'cupom.regra.idadeMax': {
    label: 'Idade máxima',
    attribute: 'QT_IDADE_MAX',
    table: 'CP_REGRA_FAIXA_ETARIA',
    type: 'NUMBER(3)',
  },

  // ── Passo 5: Combo ──
  'cupom.combo.filho': {
    label: 'Cupom-filho',
    attribute: 'NR_SEQ_CUPOM_FILHO',
    table: 'CP_CUPOM_COMBO',
    type: 'NUMBER(10)',
    description: 'Linha pai-filho com offsets de liberação/validade.',
  },
  'cupom.dependencia': {
    label: 'Cupom pré-requisito',
    attribute: 'NR_SEQ_CUPOM_REQUERIDO',
    table: 'CP_REGRA_DEPENDENCIA',
    type: 'NUMBER(10)',
  },
};
